angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetSwipeRateGraph', ($q, $translate, BaseCampaignInterestWidgetGraph, Chart) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      addSeries = (swipe_rate_stats) ->
        scope.chartConfig.series = [
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetSwipeRateGraph.productSwipe')
          data: swipe_rate_stats
        ]

      scope.getStats = ->
        $q.all [
          scope.getCampaignEventStats('click_badge')
          scope.getCampaignEventStats($in: ['interest_item_swiped', 'view_content_scrolled'])
        ]

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'line',
          options:
            tooltip:
              valueSuffix: '%'
              valueDecimals: 2
            legend: false

      scope.addChartConfig = ([badge_click_stats, interest_item_swiped_stats]) ->
        swipe_count_by_start_at = {}
        for interest_item_swiped_stat in interest_item_swiped_stats
          start_at = interest_item_swiped_stat.start_at.valueOf()
          swipe_count_by_start_at[start_at] = interest_item_swiped_stat.count
        swipe_rate_stats = []
        for badge_click_stat in badge_click_stats
          start_at = badge_click_stat.start_at.valueOf()
          swipe_count = swipe_count_by_start_at[start_at] or 0
          swipe_rate = if badge_click_stat.count then swipe_count / badge_click_stat.count * 100 else 0
          swipe_rate_stats.push [start_at, swipe_rate]
        addSeries(swipe_rate_stats)

  return new Graph('daily').createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_swipe_rate_graph.coffee